import { api } from "./apiClient";

export const photosAPI = {
    listByProject: (projectId) =>
        api.get(`/projects/${projectId}/photos`),

    upload: (projectId, formData) =>
        api.post(`/projects/${projectId}/photos`, formData),

    delete: (projectId, photoId) =>
        api.delete(`/projects/${projectId}/photos/${photoId}`),
};
